/**
 * Bounds and presets for the org-wide tag polling interval. They mirror the
 * proxy's `registry.MinPollFrequencyMs` / `MaxPollFrequencyMs` /
 * `DefaultPollFrequencyMs` and the `tag_polling_settings` CHECK constraint.
 */
import { buildCadenceOptions, type CadenceOption } from '../connection-health/cadence'

export const MIN_POLL_INTERVAL_MS = 1000
export const MAX_POLL_INTERVAL_MS = 3600000
export const DEFAULT_POLL_INTERVAL_MS = 5000

const POLL_PRESETS_MS = [
  1000, 2000, 5000, 10000, 15000, 30000, 60000, 120000, 300000, 600000, 900000, 1800000, 3600000
]

/** Select options: the presets plus an in-range current value set via the API. */
export function buildPollIntervalOptions(currentMs?: number): CadenceOption[] {
  const inRange =
    typeof currentMs === 'number' &&
    currentMs >= MIN_POLL_INTERVAL_MS &&
    currentMs <= MAX_POLL_INTERVAL_MS
  return buildCadenceOptions(inRange ? currentMs : undefined, POLL_PRESETS_MS)
}
